import { render, staticRenderFns } from "./BatchListType.vue?vue&type=template&id=0ddbb1eb&scoped=true"
import script from "./BatchListType.vue?vue&type=script&lang=ts"
export * from "./BatchListType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddbb1eb",
  null
  
)

export default component.exports